var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVineRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5608 7.72611e-06C42.5608 7.72611e-06 43.1368 1.4873 43.464 3.53478L43.4752 3.5908C43.5003 3.78967 43.5311 3.98853 43.5535 4.1958L43.5535 4.20701C43.9198 7.2124 43.629 11.1197 40.4272 13.4473C34.6919 17.6179 22.9558 11.5931 22.9558 11.5931C22.9558 11.5931 24.3707 11.425 26.44 10.9656C31.6747 9.80326 41.1207 6.79506 42.5608 0.00281153L42.5608 7.72611e-06Z",
    fill: "url(#paint0_linear_10020_170268)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5507 4.2042C43.917 7.20959 43.6262 11.1169 40.4244 13.4445C34.6892 17.615 22.9531 11.5902 22.9531 11.5902C22.9531 11.5902 24.368 11.4222 26.4373 10.9628C26.4373 10.9628 33.2994 15.7888 38.6404 13.1532C42.8488 11.0749 43.6737 5.76711 43.5507 4.20139L43.5507 4.2042Z",
    fill: "url(#paint1_linear_10020_170268)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.71476e-06 18C4.72092e-06 15 0.567777 15 2.5 12.6602C8 6 31.8034 11.3382 48.4302 20.9565C65.0571 30.5749 57.5798 39.4651 56.5228 52.9123C55.4686 66.3596 68.505 80.1066 68.505 80.1066C68.505 80.1066 55.9691 67.9897 55.3427 56.3155C54.7164 44.6412 60.1384 40.3698 56.7996 30.9531C53.4636 21.5363 21.0683 12.0664 12.1341 12.6602C9 15 10.0212 15.1459 8.5 18C5 18 3.5 18 3.5 18L-2.71476e-06 18Z",
    fill: "url(#paint2_linear_10020_170268)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9719 51.2934C61.3604 62.8444 77.2183 62.9677 77.2183 62.9677C77.2183 62.9677 74.8974 66.1775 71.2929 67.6704C71.2929 67.6704 71.2929 67.676 71.2873 67.676C69.1202 68.5807 66.4889 68.858 63.617 67.4436C58.0803 64.7155 56.5507 57.4694 56.1285 53.6826L56.1285 53.677C55.9691 52.2345 55.9691 51.2962 55.9691 51.2962L55.9719 51.2934Z",
    fill: "url(#paint3_linear_10020_170268)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4266 57.167L56.7996 62.8725C56.7996 62.8725 56.8304 62.9313 56.8835 63.0517C56.8835 63.0517 56.8891 63.0517 56.8891 63.0573C57.5882 64.5334 62.1433 74.4935 59.4393 78.7873C57.1715 82.3893 51.4754 82.14 49.0398 81.8459C48.3296 81.7619 47.8989 81.6723 47.8989 81.6723C47.8989 81.6723 50.2059 82.0504 53.7153 73.5132C57.0037 65.5165 55.6168 58.0829 55.4266 57.167Z",
    fill: "url(#paint4_linear_10020_170268)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5747 68.83C60.9466 69.1129 74.4332 79.1683 82 76.7959C82 76.7959 77.7916 81.1849 72.4143 81.2494L72.4087 81.2494C71.4915 81.2634 70.5435 81.1513 69.5704 80.8656C62.9068 78.9218 60.5663 68.8244 60.5663 68.8244L60.5775 68.83L60.5747 68.83Z",
    fill: "url(#paint5_linear_10020_170268)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8315 31.4516L58.7039 32.2163C58.7039 32.2163 69.2572 42.9999 80.7892 42.4985C80.7892 42.4985 80.339 42.787 79.57 43.1931C77.0338 44.5348 71.0301 47.1929 66.254 45.2658C61.531 43.3668 59.1346 36.4205 58.2453 33.1602L58.2397 33.149C57.9629 32.1099 57.8343 31.4488 57.8343 31.4488L57.8315 31.4516Z",
    fill: "url(#paint6_linear_10020_170268)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3444 16.2986C60.3146 17.0997 67.3725 21.175 70.1129 22.878C70.8567 23.3401 71.2845 23.6286 71.2845 23.6286C71.2845 23.6286 70.7001 24.9199 62.5572 25.9842C54.6185 27.0178 42.6559 18.1976 42.0463 17.7383C42.0267 17.7243 42.0155 17.7187 42.0155 17.7187C42.0155 17.7187 48.6791 15.5367 54.3444 16.2986Z",
    fill: "url(#paint7_linear_10020_170268)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9938 19.0435C40.8466 19.276 41.9036 19.5953 43.0389 20.007C45.578 20.9202 48.5225 22.2982 50.5415 24.2252C50.8686 24.5333 51.1678 24.8611 51.4335 25.2C51.4335 25.2 51.4391 25.2056 51.4447 25.2112C52.4681 26.4828 53.0665 27.9645 52.9631 29.6731C52.4709 37.6781 42.3594 40.7115 42.0463 40.8011C42.1022 40.7367 42.5524 40.2494 43.1732 39.4455L43.1872 39.4315C45.2257 36.7762 49.0231 30.729 46.1792 25.4268C44.7056 22.6847 43.1228 21.0322 41.7387 20.0407C41.1039 19.5897 40.5139 19.2704 39.991 19.0463L39.9938 19.0435Z",
    fill: "url(#paint8_linear_10020_170268)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7093 12.3467C24.4808 13.5651 26.5529 18.4108 27.2883 22.1472L27.2883 22.1528C27.7805 24.696 27.6547 26.7239 27.6547 26.7239C27.6547 26.7239 22.5346 21.1473 16.6456 18.6236C10.7565 16.1028 6.00281 17.9234 6.00281 17.9234C6.00281 17.9234 6.70748 16.1252 8.54745 14.5147C10.4937 12.8005 13.7122 11.2992 18.7093 12.3467Z",
    fill: "url(#paint9_linear_10020_170268)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8175 35.3533C57.8175 35.3533 57.9126 37.2916 57.6693 39.6808C57.3309 43.0503 56.3298 47.3189 53.4664 48.274C48.5729 49.9098 39.1633 52.0413 39.1633 52.0413C39.1633 52.0413 39.1633 52.0357 39.1689 52.0301C39.2136 51.7976 40.0525 48.0555 43.9366 45.1034C47.9465 42.0559 56.9562 43.3444 57.8203 35.3533L57.8175 35.3533Z",
    fill: "url(#paint10_linear_10020_170268)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1005 17.6405C25.4987 19.2846 26.5277 20.8111 27.2855 22.1472L27.2855 22.1528C27.7777 24.696 27.6519 26.7239 27.6519 26.7239C27.6519 26.7239 22.5318 21.1473 16.6428 18.6236C10.7537 16.1028 6 17.9234 6 17.9234C6 17.9234 6.86965 16.4641 9.05917 15.3745C11.2962 14.2626 19.8334 12.61 24.1005 17.6405Z",
    fill: "url(#paint11_linear_10020_170268)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1129 22.8808C70.8567 23.3429 71.2845 23.6314 71.2845 23.6314C71.2845 23.6314 70.7001 24.9227 62.5572 25.987C54.6185 27.0206 42.6559 18.2004 42.0463 17.7411C42.667 18.1276 52.7002 24.3513 59.8588 24.9731C64.4531 25.3708 68.0492 23.9844 70.1157 22.8808L70.1129 22.8808Z",
    fill: "url(#paint12_linear_10020_170268)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1483 24.9759C51.179 24.9955 51.2825 25.0739 51.4363 25.2C51.4363 25.2 51.4419 25.2056 51.4475 25.2112C52.4709 26.4828 53.0693 27.9645 52.9659 29.6731C52.4737 37.6781 42.3623 40.7115 42.0491 40.8011C42.105 40.7367 42.5552 40.2494 43.176 39.4455L43.19 39.4315C43.19 39.4315 49.1377 36.4149 50.9246 32.3059C52.6667 28.3006 51.221 25.144 51.1483 24.9815L51.1483 24.9759Z",
    fill: "url(#paint13_linear_10020_170268)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6693 39.6836C57.3309 43.0531 56.3298 47.3217 53.4664 48.2768C48.5729 49.9126 39.1633 52.0441 39.1633 52.0441C39.1633 52.0441 39.1633 52.0385 39.1689 52.0329C39.3087 51.7808 41.9316 47.0276 46.3834 45.1062C50.9581 43.1343 55.6615 42.8738 56.9758 40.8067C57.2526 40.3698 57.4819 40.0029 57.6693 39.6836Z",
    fill: "url(#paint14_linear_10020_170268)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8315 31.4516L58.7039 32.2163C58.7039 32.2163 69.2572 42.9998 80.7892 42.4985C80.7892 42.4985 80.339 42.787 79.57 43.1931C77.1233 43.4032 73.8292 43.476 71.2845 42.7506C66.665 41.4341 58.2453 33.1602 58.2453 33.1602L58.2397 33.149C57.9629 32.1098 57.8343 31.4488 57.8343 31.4488L57.8315 31.4516Z",
    fill: "url(#paint15_linear_10020_170268)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9719 51.2934C61.3604 62.8444 77.2183 62.9677 77.2183 62.9677C77.2183 62.9677 74.8974 66.1775 71.2929 67.6704C71.4663 67.5052 73.8236 65.2644 73.5803 64.4746C73.3314 63.6595 58.8046 61.7717 56.1313 53.6798L56.1313 53.6742C55.9719 52.2317 55.9719 51.2934 55.9719 51.2934Z",
    fill: "url(#paint16_linear_10020_170268)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5747 68.83C60.9466 69.1129 74.4332 79.1683 82 76.7959C82 76.7959 77.7916 81.1849 72.4143 81.2494C72.7079 81.2101 77.4169 80.4987 77.6546 79.0366C77.9062 77.5297 65.2697 74.4543 60.5663 68.8244L60.5775 68.83L60.5747 68.83Z",
    fill: "url(#paint17_linear_10020_170268)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8891 63.0573C57.5882 64.5334 62.1434 74.4935 59.4393 78.7873C57.1715 82.3893 51.4754 82.14 49.0399 81.8459C49.0399 81.8459 54.845 76.7763 56.2851 72.1939C57.2331 69.1885 57.0932 65.3401 56.8891 63.0545L56.8891 63.0573Z",
    fill: "url(#paint18_linear_10020_170268)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.5951 22.5475C66.1253 23.9199 57.1324 24.7938 51.8557 22.7687C46.5791 20.7437 45.8185 18.0184 45.8185 18.0184C45.8185 18.0184 51.1706 14.7077 57.0037 16.8392C62.8368 18.9735 66.5951 22.5447 66.5951 22.5447L66.5951 22.5475Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2285 37.3952C44.9824 38.0674 49.8871 34.8408 50.8295 31.4516C51.7719 28.0625 48.7602 26.0682 48.7602 26.0682C48.7602 26.0682 46.7693 33.1686 45.2257 37.3952L45.2285 37.3952Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1021 35.3533C60.1021 35.3533 61.1143 42.0755 65.3731 44.0082C69.6319 45.9408 72.0619 43.6973 72.0619 43.6973C72.0619 43.6973 69.4417 42.5349 67.1571 40.6023C64.8726 38.6696 60.1021 35.3505 60.1021 35.3505L60.1021 35.3533Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9319 21.9061C49.9319 21.9061 51.1874 21.7128 52.9771 21.9061C54.7667 22.0993 55.9719 24.214 55.9719 24.214C55.9719 24.214 51.7131 23.0152 49.9319 21.9061Z",
    fill: "#83EF72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1651 31.0035C51.1651 31.0035 50.0801 30.6198 49.9291 30.1492C49.7781 29.6786 51.7663 28.7403 51.7663 28.7403C51.7663 28.7403 51.5929 30.25 51.1651 31.0007L51.1651 31.0035Z",
    fill: "#83EF72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6521 41.0084C67.6521 41.0084 66.3295 41.3277 65.1522 40.8011C63.975 40.2746 63.0578 37.4848 63.0578 37.4848C63.0578 37.4848 65.8625 40.0281 67.6521 41.0084Z",
    fill: "#83EF72"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0578 67.1383C65.5353 68.1522 67.6857 65.0376 67.1572 63.8444C66.6259 62.6512 60.3677 60.7213 57.837 57.1641C57.837 57.1641 57.0457 63.5867 63.0578 67.1355L63.0578 67.1383Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8584 80.6079C73.2391 81.1093 70.798 77.4597 68.052 75.0397C65.3088 72.6169 61.6736 70.3761 61.6736 70.3761C61.6736 70.3761 63.0018 78.3476 69.8584 80.6079Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.666 21.2254C55.4546 24.3933 61.4331 23.9675 62.4342 22.1385C63.4381 20.3095 56.9199 15.6656 54.2242 16.6683C51.5286 17.6739 54.666 21.2226 54.666 21.2226L54.666 21.2254Z",
    fill: "#9BC672"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9113 10.5007C29.639 13.2652 35.7154 14.0719 39.3171 12.1812C42.9187 10.2906 42.1218 5.15089 41.4311 4.96323C40.7404 4.77557 30.9113 10.5035 30.9113 10.5035L30.9113 10.5007Z",
    fill: "#9BC672"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10020_170268",
    x1: 41.2101,
    y1: 7.45608,
    x2: 20.4447,
    y2: 7.45608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10020_170268",
    x1: 42.1889,
    y1: 9.55677,
    x2: 24.0492,
    y2: 9.55677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10020_170268",
    x1: 59.9846,
    y1: 45.1062,
    x2: -11.7548,
    y2: 45.1062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10020_170268",
    x1: 74.0697,
    y1: 63.6707,
    x2: 51.31,
    y2: 56.9521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D7738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#227A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#318430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4B9427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10020_170268",
    x1: 60.3341,
    y1: 71.9867,
    x2: 50.3123,
    y2: 69.0295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D7738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#227A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#318430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4B9427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10020_170268",
    x1: 78.5662,
    y1: 78.8434,
    x2: 56.6373,
    y2: 72.3733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D7738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#227A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#318430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4B9427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10020_170268",
    x1: 78.0572,
    y1: 38.7004,
    x2: 55.0491,
    y2: 38.7004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10020_170268",
    x1: 67.8003,
    y1: 21.105,
    x2: 38.467,
    y2: 21.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10020_170268",
    x1: 51.4307,
    y1: 29.9223,
    x2: 38.4222,
    y2: 29.9223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10020_170268",
    x1: 26.5977,
    y1: 20.5283,
    x2: 4.24081,
    y2: 13.9297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D7738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#227A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#318430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#4B9427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10020_170268",
    x1: 55.6112,
    y1: 43.6973,
    x2: 36.8983,
    y2: 43.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#519B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6AA91C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EAB1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10020_170268",
    x1: 26.1139,
    y1: 20.461,
    x2: 7.14649,
    y2: 20.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10020_170268",
    x1: 69.1873,
    y1: 21.9061,
    x2: 43.587,
    y2: 21.9061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10020_170268",
    x1: 52.1913,
    y1: 32.8885,
    x2: 42.6251,
    y2: 32.8885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10020_170268",
    x1: 56.341,
    y1: 45.8624,
    x2: 40.1392,
    y2: 45.8624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10020_170268",
    x1: 79.1422,
    y1: 37.3952,
    x2: 59.0451,
    y2: 37.3952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10020_170268",
    x1: 75.6943,
    y1: 59.4805,
    x2: 57.0932,
    y2: 59.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10020_170268",
    x1: 80.4621,
    y1: 75.0397,
    x2: 61.6988,
    y2: 75.0397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10020_170268",
    x1: 59.4813,
    y1: 72.5273,
    x2: 49.6327,
    y2: 72.5273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCA6A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#CAA0A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C491A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BB78A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B464A5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVineRight);
export default ForwardRef;